import React from "react";

/** Thin gold ornamental divider with a central rosette. */
export const OrnamentDivider = ({ label, className = "" }) => (
  <div
    className={`flex items-center justify-center gap-5 text-gold ${className}`}
    aria-hidden={!label}
  >
    <span className="block h-px w-16 md:w-24 bg-gradient-to-r from-transparent via-current to-current opacity-70" />
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" stroke="currentColor" strokeWidth="0.8">
      <circle cx="17" cy="17" r="2.2" fill="currentColor" stroke="none" />
      <circle cx="17" cy="17" r="6" />
      <circle cx="17" cy="17" r="11" opacity="0.55" />
      <path d="M17 0 L17 5 M17 29 L17 34 M0 17 L5 17 M29 17 L34 17" />
    </svg>
    {label && (
      <span className="font-serif italic text-base md:text-lg whitespace-nowrap">
        {label}
      </span>
    )}
    <span className="block h-px w-16 md:w-24 bg-gradient-to-l from-transparent via-current to-current opacity-70" />
  </div>
);

/** Hand-drawn wavy line — sea/garden style divider. */
export const WaveDivider = ({ className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 800 60"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    className={className}
  >
    <path d="M0 30 C 80 5, 160 5, 240 30 S 400 55, 480 30 S 640 5, 720 30 S 800 45, 800 30" />
    <path
      d="M0 38 C 80 18, 160 18, 240 38 S 400 58, 480 38 S 640 18, 720 38 S 800 50, 800 38"
      opacity="0.45"
    />
  </svg>
);

/** Art-nouveau style botanical corner ornament. */
export const BotanicalCorner = ({ className = "", flip = false }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 160 160"
    fill="none"
    stroke="currentColor"
    strokeWidth="0.85"
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
  >
    <path d="M5 155 C 25 120, 30 90, 45 70 C 60 50, 80 35, 100 20 C 115 10, 135 5, 155 5" />
    <path d="M30 130 C 38 120, 38 110, 32 100" />
    <path d="M50 110 C 58 100, 60 88, 54 78" />
    <path d="M70 90 C 78 80, 82 68, 76 58" />
    <path d="M92 70 C 100 60, 104 48, 98 38" />
    {/* leaves */}
    <path d="M40 122 C 30 118, 26 108, 36 102 C 44 110, 44 118, 40 122 Z" />
    <path d="M62 100 C 52 96, 48 86, 58 80 C 66 88, 66 96, 62 100 Z" />
    <path d="M86 80 C 76 76, 72 66, 82 60 C 90 68, 90 76, 86 80 Z" />
    <path d="M110 58 C 100 54, 96 44, 106 38 C 114 46, 114 54, 110 58 Z" />
    {/* small bud */}
    <circle cx="125" cy="22" r="3" fill="currentColor" stroke="none" opacity="0.7" />
    <circle cx="135" cy="14" r="2" fill="currentColor" stroke="none" opacity="0.55" />
  </svg>
);

/** Gulls silhouette — minimal stroke. */
export const Gull = ({ className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 60 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    className={className}
  >
    <path d="M2 16 C 10 4, 18 4, 26 14 M26 14 C 34 4, 42 4, 50 16" />
  </svg>
);

/** Decorative fleuron / rosette icon. */
export const Fleuron = ({ className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M12 2c1 3 3 5 6 6-3 1-5 3-6 6-1-3-3-5-6-6 3-1 5-3 6-6z" />
    <circle cx="12" cy="12" r="1.4" fill="white" />
  </svg>
);
